import React, { useState } from "react";
import { Button, Table } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";
import { useRouteLoaderData } from "react-router-dom";

import { useAppApi } from "@/App";
import { useRequest } from "@components/AppHook";
import { DevForm } from "@components/Forms/Fields";
import { CommonCard } from "@components/Pages";

export function AccountTable({ apiUrl, header }) {
    const { t } = useTranslation();
    const { apiData, setApiData } = useAppApi(apiUrl);
    const [search, setSearch] = useState(null);
    const commonInfo = useRouteLoaderData("commonInfo");
    const { api_post, api_delete } = useRequest();

    if (!apiData) return;

    const addNewTR = () => {
        const newApiData = { ...apiData };
        newApiData.object_list.unshift({});
        setApiData(newApiData);
    };

    const toggleOwnerPermissions = (index, value) => {
        const permissions = ["can_own", "can_edit", "can_distribution", "can_statistics", "can_smm"];
        const newApiData = { ...apiData };
        const object = newApiData.object_list[index];

        permissions.forEach((perm) => {
            object[perm] = value;
        });

        object.changed = true;

        setApiData(newApiData);
    };

    const changePerm = (ev, ind) => {
        const { name } = ev.target;
        if (name === "can_own") {
            toggleOwnerPermissions(ind, ev.target.checked);
            return;
        }

        const value = ev.target.type === "checkbox" ? ev.target.checked : ev.target.value;
        const newApiData = { ...apiData };
        newApiData.object_list[ind][name] = value;
        newApiData.object_list[ind].changed = true;
        setApiData(newApiData);
    };

    const savePerm = (ev, ind) => {
        const params = apiData.object_list[ind];
        if (!params.login) {
            return;
        }
        api_post(ev, apiUrl, {
            params,
            then: (resp) => {
                if (resp.status === "ok") setApiData(resp);
            },
        });
    };

    const delPerm = (ev, login) => {
        api_delete(ev, apiUrl + "?login=" + encodeURIComponent(login), {
            then: (resp) => {
                if (resp.status === "ok") setApiData(resp);
            },
        });
    };

    return (
        <CommonCard header={header}>
            <div className="dmg-callout dmg-callout-info">
                <Trans>
                    1. СКОПИРОВАТЬ{" "}
                    <a href="https://account.vkplay.ru/profile/security/" target="_blank">
                        ЛОГИН
                    </a>
                    .
                </Trans>
                <br />
                <Trans>2. Добавить ниже, проставить роли, сохранить.</Trans>
                <br />
                <br />
                <Trans>
                    <a href="https://documentation.vkplay.ru/f2p_vkp/f2p_manage_accs_vkp" target="_blank">
                        Подробнее
                    </a>
                </Trans>
            </div>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th style={{ width: "220px" }}>
                            <DevForm.TextInput
                                size="sm"
                                placeholder={t("Поиск")}
                                value={search}
                                onChange={(ev) => setSearch(ev.target.value || null)}
                            />
                        </th>
                        <th>{t("Владелец")}</th>
                        <th>{t("Разработчик")}</th>
                        <th>{t("Билд-менеджер")}</th>
                        <th>{t("Аналитик")}</th>
                        <th>{t("Тестировщик")}</th>
                        <th>{t("Комьюнити-менеджер")}</th>
                        <th>{t("Комментарий")}</th>
                        <th style={{ width: "110px" }}>
                            <Button size="sm" variant="outline-success" onClick={addNewTR}>
                                {t("Добавить")}
                            </Button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o, ind) => {
                        if (search && o.login && o.login.indexOf(search) < 0) {
                            return null;
                        }
                        return (
                            <tr
                                key={`object_list${ind}`}
                                className={commonInfo.account.is_super && o.is_problem ? "table-danger" : ""}
                            >
                                <td>
                                    <DevForm.TextInput
                                        size="sm"
                                        name="login"
                                        value={o.login}
                                        disabled={Boolean(o.id)}
                                        onChange={(ev) => changePerm(ev, ind)}
                                    />
                                </td>
                                <td>
                                    <DevForm.Checkbox
                                        name="can_own"
                                        checked={o.can_own || false}
                                        onChange={(ev) => changePerm(ev, ind)}
                                        disabled={o.can_own && o.id && o.login === commonInfo.account.login}
                                    />
                                </td>
                                <td>
                                    <DevForm.Checkbox
                                        name="can_edit"
                                        checked={o.can_edit || false}
                                        onChange={(ev) => changePerm(ev, ind)}
                                        disabled={false}
                                    />
                                </td>
                                <td>
                                    <DevForm.Checkbox
                                        name="can_distribution"
                                        checked={o.can_distribution || false}
                                        onChange={(ev) => changePerm(ev, ind)}
                                        disabled={false}
                                    />
                                </td>
                                <td>
                                    <DevForm.Checkbox
                                        name="can_statistics"
                                        checked={o.can_statistics || false}
                                        onChange={(ev) => changePerm(ev, ind)}
                                        disabled={false}
                                    />
                                </td>
                                <td>
                                    <DevForm.Checkbox checked={true} disabled />
                                </td>
                                <td>
                                    <DevForm.Checkbox
                                        name="can_smm"
                                        checked={o.can_smm || false}
                                        onChange={(ev) => changePerm(ev, ind)}
                                        disabled={false}
                                    />
                                </td>
                                <td>
                                    <DevForm.TextInput
                                        name="comment"
                                        placeholder={t("Комментарий для пользователя")}
                                        value={o.comment}
                                        size="sm"
                                        onChange={(ev) => changePerm(ev, ind)}
                                    />
                                </td>
                                <td>
                                    {o.id && !o.changed && !(o.can_own && o.login === commonInfo.account.login) && (
                                        <DevForm.Button
                                            size="sm"
                                            variant="outline-danger"
                                            name="del_perms"
                                            value={o.id}
                                            onClick={(ev) => delPerm(ev, o.login)}
                                        >
                                            {t("Удалить")}
                                        </DevForm.Button>
                                    )}
                                    {o.changed && (
                                        <DevForm.Button
                                            size="sm"
                                            variant="outline-primary"
                                            name="save_perms"
                                            onClick={(ev) => savePerm(ev, ind)}
                                        >
                                            {t("Сохранить")}
                                        </DevForm.Button>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </CommonCard>
    );
}
